import { defineStyle, defineStyleConfig } from '@chakra-ui/react'

const cardCore = defineStyle({
  bgColor: 'white',
  boxShadow: 'sm',
  borderRadius: 'md',
  overflow: 'hidden',
  maxW: '100%',
})

const asButton = defineStyle({
  cursor: 'pointer',
  // transition: 'background-color 200ms',
  _hover: {
    boxShadow: 'xl',
    // bg: '#eee',
  },
})

export default defineStyleConfig({
  variants: {
    card: {
      ...cardCore,
      padding: 4,
    },
    'dark-card': {
      p: 0,
      maxW: '100%',
      borderRadius: 'md',
      bg: '#555555cc',
      color: 'white',
      boxShadow: 'sm',
      overflow: 'hidden',
    },
    'button-card': {
      ...cardCore,
      ...asButton,
      padding: 4,
    },
    blank: {
      p: 4,
      borderRadius: 'md',
      border: '1px solid',
      borderColor: 'white',
    },
  },
})
